import React from 'react';
import { LayoutDashboard, Users, Megaphone, Star, Globe, User, Search, ChevronDown, Filter, Copy, Link2 } from 'lucide-react';
export const Sidebar = ({
  active
}: {
  active: string;
}) => {
  const menu = [{
    name: 'Dashboard',
    icon: LayoutDashboard
  }, {
    name: 'Roster Database',
    icon: Users
  }, {
    name: 'Casting Calls',
    icon: Megaphone
  }, {
    name: 'Talent Agencies',
    icon: Star
  }, {
    name: 'The Creator Network',
    icon: Globe,
    badge: 'New'
  }];
  return <div className="w-48 border-r border-gray-100 bg-white flex flex-col shrink-0 hidden md:flex" data-id="element-1581" data-mp="17q1iemzc1gk0">
      <div className="p-4" data-id="element-1582" data-mp="12rgjqrzqb4xo">
        <div className="text-xl font-extrabold text-zano-pink lowercase tracking-tight" data-id="element-1583" data-mp="12s8fq3x8n4oh">
          zano
        </div>
      </div>
      <div className="px-3 py-2 text-[10px] font-semibold text-gray-400 uppercase tracking-wider" data-id="element-1584" data-mp="323j9ul2uyxkb">
        Main Menu
      </div>
      <div className="space-y-0.5 px-2" data-id="element-1585" data-mp="3eqov2lrvb1ov">
        {menu.map(m => <div key={m.name} className={`flex items-center gap-2 px-2 py-1.5 rounded-md text-xs font-medium cursor-pointer ${active === m.name ? 'bg-pink-50 text-zano-pink' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-1586" data-mp="3epdt8rhzg40e">
            <m.icon size={14} className={active === m.name ? 'text-zano-pink' : 'text-gray-400'} data-id="element-1587" data-mp="39r2h2a47thf0" />
            <span className="truncate" data-id="element-1588" data-mp="1canoy46ciw1">{m.name}</span>
            {m.badge && <span className="ml-auto text-[8px] bg-pink-100 text-zano-pink px-1.5 py-0.5 rounded-sm" data-id="element-1589" data-mp="69k9m3scucf4">
                {m.badge}
              </span>}
          </div>)}
      </div>
    </div>;
};
export const Topbar = ({
  title,
  subtitle
}: {
  title: string;
  subtitle?: string;
}) => <div className="flex items-center justify-between p-4 border-b border-gray-100 bg-white" data-id="element-1590" data-mp="k9v4dhwscb5k">
    <div data-id="element-1591" data-mp="p250xgseo9gt">
      <h1 className="text-lg font-bold text-gray-900" data-id="element-1592" data-mp="p2xvzki05aj4">{title}</h1>
      {subtitle && <p className="text-xs text-gray-500" data-id="element-1593" data-mp="ywalah8bnjga">{subtitle}</p>}
    </div>
    <div className="flex items-center gap-2" data-id="element-1594" data-mp="tyihaouek6vq">
      <div className="w-6 h-6 bg-gray-200 rounded-full flex items-center justify-center text-gray-500" data-id="element-1595" data-mp="tys8ugv3im3j">
        <User size={12} data-id="element-1596" data-mp="oxl0ogp1jkwc" />
      </div>
      <span className="text-xs font-medium text-gray-700 hidden sm:inline" data-id="element-1597" data-mp="kxkluuy157or">
        Sapir Tori
      </span>
    </div>
  </div>;
export const MockupLayout = ({
  active,
  title,
  subtitle,
  children
}: any) => <div className="bg-gray-50 rounded-xl border border-gray-200 shadow-sm overflow-hidden flex h-[400px] text-left w-full" data-id="element-1598" data-mp="b813dqe8bfuf">
    <Sidebar active={active} data-id="element-1599" data-mp="67wmw0dbml47" />
    <div className="flex-1 flex flex-col overflow-hidden min-w-0" data-id="element-1600" data-mp="697lllrwt2og">
      <Topbar title={title} subtitle={subtitle} data-id="element-1601" data-mp="1acxq5f34nxh" />
      <div className="flex-1 overflow-auto p-4" data-id="element-1602" data-mp="17idoezzh54l">{children}</div>
    </div>
  </div>;
export const TTIco = () => <span className="text-[10px] font-bold" data-id="element-1603" data-mp="3tf6yvw99fn03">TT</span>;
export const IGIco = () => <span className="text-[10px] font-bold text-pink-500" data-id="element-1604" data-mp="3of2rqwu8s4mj">IG</span>;
export const YTIco = () => <span className="text-[10px] font-bold text-red-500" data-id="element-1605" data-mp="23vz1g25vln26">YT</span>;
export const DirectoryMockup = () => {
  const agencies = [{
    name: 'United Talent Agency',
    short: 'UTA',
    inf: '895',
    tt: '2B',
    ig: '1B',
    yt: '0',
    email: 'CreatorsBrandPartnerships@unitedtalent.com'
  }, {
    name: 'Clicks Talent',
    short: 'CT',
    inf: '886',
    tt: '393M',
    ig: '285M',
    yt: '917M',
    email: 'ab@clickstalent.com',
    link: true
  }, {
    name: 'Viral Nation Inc',
    short: 'VN',
    inf: '442',
    tt: '759M',
    ig: '274M',
    yt: '286M',
    email: 'ena@viralnation.com',
    link: true
  }, {
    name: 'Viral Hub Marketing',
    short: 'VH',
    inf: '190',
    tt: '38M',
    ig: '14M',
    yt: '8M',
    email: 'daniel@viralhubmarketing.com',
    link: true
  }, {
    name: 'Connect Management',
    short: 'CM',
    inf: '150',
    tt: '232M',
    ig: '57M',
    yt: '20M',
    email: 'oliver@connectmgt.com',
    link: true
  }];
  return <MockupLayout active="Talent Agencies" title="Talent Agencies" data-id="element-1606" data-mp="3469ti6ha9zfi">
      <div className="bg-white border border-gray-200 rounded-lg overflow-x-auto" data-id="element-1607" data-mp="3hwvd5xekadeg">
        <table className="w-full text-left text-xs whitespace-nowrap" data-id="element-1608" data-mp="3d4v8jrnjqwbj">
          <thead className="bg-white border-b border-gray-100 text-gray-500" data-id="element-1609" data-mp="3ru1495n6e4eo">
            <tr data-id="element-1610" data-mp="3rw44eii1ldx4">
              <th className="px-3 py-2 font-medium" data-id="element-1611" data-mp="3muwwmjfwgeqg">Name</th>
              <th className="px-3 py-2 font-medium" data-id="element-1612" data-mp="3mueqmv3fqm5c">Creators ↑</th>
              <th className="px-3 py-2 font-medium" data-id="element-1613" data-mp="4pld32e5wpcq">
                <TTIco data-id="element-1614" data-mp="4n7ewko6qx0y" />
              </th>
              <th className="px-3 py-2 font-medium" data-id="element-1615" data-mp="ngj22jsxqpk">
                <IGIco data-id="element-1616" data-mp="lm0uvzx0cp6" />
              </th>
              <th className="px-3 py-2 font-medium" data-id="element-1617" data-mp="26fwrcemms25y">
                <YTIco data-id="element-1618" data-mp="26ircy9hdrt0y" />
              </th>
              <th className="px-3 py-2 font-medium" data-id="element-1619" data-mp="22fuz0w2scl3c">Website</th>
              <th className="px-3 py-2 font-medium" data-id="element-1620" data-mp="22hfv4q4r0c3b">Email</th>
              <th className="px-3 py-2 font-medium" data-id="element-1621" data-mp="1scfzall6igo4"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50" data-id="element-1622" data-mp="1wbgbvmd2cn2o">
            {agencies.map((a, i) => <tr key={i} className="hover:bg-gray-50" data-id="element-1623" data-mp="1ika8hf6ny5ai" data-mpi={i}>
                <td className="px-3 py-2 flex items-center gap-2" data-id="element-1624" data-mp="1nkg0wxkrbvtn">
                  <div className="w-6 h-6 bg-gray-900 text-white rounded-full flex items-center justify-center text-[8px] font-bold shrink-0" data-id="element-1625" data-mp="1nilh5ml829r5">
                    {a.short}
                  </div>
                  <span className="font-medium text-gray-900" data-id="element-1626" data-mp="1dnjrmpn1b5o1">{a.name}</span>
                </td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1627" data-mp="zo20w4q6hic1">{a.inf}</td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1628" data-mp="14ksfenmc45vc">{a.tt}</td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1629" data-mp="2u0ia9ee9tcl4">{a.ig}</td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1630" data-mp="2u19vbva8rrx5">{a.yt}</td>
                <td className="px-3 py-2 text-gray-400" data-id="element-1631" data-mp="2yyju41jitfxn">
                  {a.link && <Link2 size={12} data-id="element-1632" data-mp="2wkogjsqcxf4u" />}
                </td>
                <td className="px-3 py-2 text-gray-500 truncate max-w-[120px]" data-id="element-1633" data-mp="2wm9b3ico8y2p">
                  {a.email}
                </td>
                <td className="px-3 py-2 text-right" data-id="element-1634" data-mp="2nk8e8mlcoe1k">
                  <div className="flex items-center justify-end gap-2" data-id="element-1635" data-mp="2nl1dz3lw63a7">
                    <Copy size={12} className="text-gray-400" data-id="element-1636" data-mp="2ilyia9rsx9ew" />
                    <button className="border border-gray-200 text-gray-700 rounded px-2 py-1 text-[10px] font-medium bg-white" data-id="element-1637" data-mp="2ini0i5x0pujb">
                      View Roster
                    </button>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </MockupLayout>;
};
export const CastingCallMockup = () => {
  const calls = [{
    name: 'Temu US campaign short form',
    budget: '$10,000 - $120,000',
    cat: '-',
    type: 'Paid Promo',
    plats: ['TT', 'IG'],
    posted: 'Braco US',
    date: 'Jun 26'
  }, {
    name: 'Kopouch World Cup Activation',
    budget: '$400 - $600',
    cat: '-',
    type: 'Paid Promo',
    plats: ['IG'],
    posted: 'Clicks Talent',
    date: 'Jun 4'
  }, {
    name: 'Leesa Summer',
    budget: '$42 - $6,000',
    cat: 'Beauty, Book Reviews...',
    type: 'Paid Promo',
    plats: ['YT'],
    posted: 'The Outloud Group',
    date: 'May 22'
  }, {
    name: 'DJI',
    budget: '-',
    cat: '-',
    type: 'Paid Promo',
    plats: ['IG'],
    posted: 'Clicks Talent',
    date: 'May 14'
  }];
  return <MockupLayout active="Casting Calls" title="Casting Calls" subtitle="24 Casting Calls" data-id="element-1638" data-mp="ta1muq421hhx">
      <div className="flex items-center justify-between mb-3" data-id="element-1639" data-mp="131xx0zjf0y2i">
        <div className="flex items-center gap-3" data-id="element-1640" data-mp="131fp35ne4ver">
          <button className="flex items-center gap-1 border border-gray-200 bg-white px-2 py-1 rounded text-xs font-medium text-gray-700" data-id="element-1641" data-mp="181tyar0qabed">
            <Filter size={12} data-id="element-1642" data-mp="1c35hoet0e0e4" /> All filters
          </button>
          <button className="text-xs text-gray-500 underline" data-id="element-1643" data-mp="1xd2qm9ub4adp">Clear all</button>
        </div>
        <button className="bg-pink-100 text-pink-600 px-3 py-1.5 rounded text-xs font-medium" data-id="element-1644" data-mp="1tcs9c112dxjj">
          + New Casting Call
        </button>
      </div>
      <div className="bg-white border border-gray-200 rounded-lg overflow-x-auto" data-id="element-1645" data-mp="279xmsm33xyot">
        <table className="w-full text-left text-xs whitespace-nowrap" data-id="element-1646" data-mp="22dglsrat7pub">
          <thead className="bg-white border-b border-gray-100 text-gray-500" data-id="element-1647" data-mp="1emkwc0ttt6q8">
            <tr data-id="element-1648" data-mp="19oje1i485bft">
              <th className="px-3 py-2 font-medium" data-id="element-1649" data-mp="19p1buj6jbxpu">Name</th>
              <th className="px-3 py-2 font-medium" data-id="element-1650" data-mp="19mf5unzalq9q">Budget</th>
              <th className="px-3 py-2 font-medium" data-id="element-1651" data-mp="1oeqq9g3n1y82">Category</th>
              <th className="px-3 py-2 font-medium" data-id="element-1652" data-mp="1jlxon13gv607">Type of Collaboration</th>
              <th className="px-3 py-2 font-medium" data-id="element-1653" data-mp="vwv33i5pot0f">Platforms</th>
              <th className="px-3 py-2 font-medium" data-id="element-1654" data-mp="vv0lodtnfj13">Posted By</th>
              <th className="px-3 py-2 font-medium" data-id="element-1655" data-mp="qwqojxod68cu">Date Posted</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50" data-id="element-1656" data-mp="32k2iiwxaw0dq">
            {calls.map((c, i) => <tr key={i} className="hover:bg-gray-50" data-id="element-1657" data-mp="37c3q45jix2xf" data-mpi={i}>
                <td className="px-3 py-2 font-medium text-gray-900 truncate max-w-[150px]" data-id="element-1658" data-mp="37dooy7cvf813">
                  {c.name}
                </td>
                <td className="px-3 py-2 text-green-600 font-medium" data-id="element-1659" data-mp="2xl97db5hklgq">
                  {c.budget}
                </td>
                <td className="px-3 py-2 text-gray-500 truncate max-w-[100px]" data-id="element-1660" data-mp="3lcwo5091ag5a">
                  {c.cat}
                </td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1661" data-mp="3q8lqfbcfub5a">{c.type}</td>
                <td className="px-3 py-2 flex gap-1" data-id="element-1662" data-mp="3ca5bix4f9ec2">
                  {c.plats.includes('TT') && <TTIco data-id="element-1663" data-mp="3h98du9t0p6gc" />}
                  {c.plats.includes('IG') && <IGIco data-id="element-1664" data-mp="3hbupakj1463u" />}
                  {c.plats.includes('YT') && <YTIco data-id="element-1665" data-mp="20uys7ng5tvt7" />}
                </td>
                <td className="px-3 py-2 text-gray-700 flex items-center gap-1" data-id="element-1666" data-mp="20y4ekuxemjl8">
                  <div className="w-4 h-4 bg-gray-200 rounded-full shrink-0" data-id="element-1667" data-mp="25srw29tzqdqb"></div>
                  <span className="truncate max-w-[100px]" data-id="element-1668" data-mp="qxcomn9zxlni">{c.posted}</span>
                </td>
                <td className="px-3 py-2 text-gray-500" data-id="element-1669" data-mp="uxwm5ryhera6">{c.date}</td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </MockupLayout>;
};
export const SubmissionsMockup = CastingCallMockup;
export const RosterDatabaseMockup = () => {
  const creators = [{
    name: 'Dr. Aamir Hussain',
    cat: 'Academia',
    country: 'United Kingdom',
    tt: '-',
    ig: '39.3K',
    yt: '2.9K',
    agency: 'KAW Management Group',
    excl: 'Non-Exclusive',
    email: 'connect@kawmanagementgroup.com'
  }, {
    name: 'Ganyah Goldstein',
    cat: 'Academia',
    country: 'United Kingdom',
    tt: '82.9K',
    ig: '38.1K',
    yt: '-',
    agency: 'Viral Hub Marketing',
    excl: 'Non-Exclusive',
    email: 'daniel@viralhubmarketing.com'
  }, {
    name: 'Julius Doyle',
    cat: 'Academia',
    country: 'United States',
    tt: '-',
    ig: '449.8K',
    yt: '-',
    agency: 'Clicks Talent',
    excl: 'Non-Exclusive',
    email: 'amaany@clickstalentagency.com'
  }, {
    name: 'Stephanie & Loreal',
    cat: 'Academia',
    country: 'United States',
    tt: '169.8K',
    ig: '456.8K',
    yt: '-',
    agency: 'Boost Society',
    excl: 'Exclusive',
    email: 'josh@boost-society.com'
  }];
  return <MockupLayout active="Roster Database" title="Roster Database" data-id="element-1670" data-mp="2lglbbe7q0l7o">
      <div className="flex items-center gap-2 mb-3 overflow-x-auto pb-1" data-id="element-1671" data-mp="2lgcxnk3rxbvf">
        <div className="relative flex-1 min-w-[120px]" data-id="element-1672" data-mp="2zfcn2tz41usn">
          <Search size={12} className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-1673" data-mp="2vesodlyw2j4e" />
          <input type="text" placeholder="Search" className="w-full pl-6 pr-2 py-1 border border-gray-200 rounded text-xs outline-none" data-id="element-1674" data-mp="151l619egc8n6" />
        </div>
        {['Platforms', 'Categories', 'Countries'].map(f => <button key={f} className="flex items-center gap-1 border border-gray-200 bg-white px-2 py-1 rounded text-xs text-gray-700 whitespace-nowrap" data-id="element-1675" data-mp="307vstcrsoz7a">
            {f} <ChevronDown size={10} data-id="element-1676" data-mp="3a61xg24zkjfu" />
          </button>)}
        <button className="flex items-center gap-1 border border-gray-200 bg-white px-2 py-1 rounded text-xs font-medium text-gray-700 whitespace-nowrap" data-id="element-1677" data-mp="3f3jzr9oi00ev">
          <Filter size={12} data-id="element-1678" data-mp="3o36zzs5hr06c" /> All filters
        </button>
        <button className="text-xs text-gray-500 underline whitespace-nowrap" data-id="element-1679" data-mp="3o1nk42nqyr53">
          Clear all
        </button>
      </div>
      <div className="bg-white border border-gray-200 rounded-lg overflow-x-auto" data-id="element-1680" data-mp="1nvzrccq11ms">
        <table className="w-full text-left text-xs whitespace-nowrap" data-id="element-1681" data-mp="1pyrq1xfp4u5">
          <thead className="bg-white border-b border-gray-100 text-gray-500" data-id="element-1682" data-mp="6ojqdwx1fggh">
            <tr data-id="element-1683" data-mp="aplr6i6ls0kk">
              <th className="px-3 py-2 font-medium" data-id="element-1684" data-mp="ap3mcx5vke11">Name</th>
              <th className="px-3 py-2 font-medium" data-id="element-1685" data-mp="1v74dyxqofoux">Category ↓</th>
              <th className="px-3 py-2 font-medium" data-id="element-1686" data-mp="1v49sr3zua00g">Country</th>
              <th className="px-3 py-2 font-medium" data-id="element-1687" data-mp="1r482rs3guv10">
                <TTIco data-id="element-1688" data-mp="1m5oe3jxhn54y" />
              </th>
              <th className="px-3 py-2 font-medium" data-id="element-1689" data-mp="1m6prhv1z83pu">
                <IGIco data-id="element-1690" data-mp="1h6tonz50mibv" />
              </th>
              <th className="px-3 py-2 font-medium" data-id="element-1691" data-mp="1h84zuk0sisd0">
                <YTIco data-id="element-1692" data-mp="2eult9e6eklth" />
              </th>
              <th className="px-3 py-2 font-medium" data-id="element-1693" data-mp="2etahar2t07ra">Agency Name</th>
              <th className="px-3 py-2 font-medium" data-id="element-1694" data-mp="29uz72f8ljv8j">Exclusivity</th>
              <th className="px-3 py-2 font-medium" data-id="element-1695" data-mp="29xv503kg2jwz">Contact Email</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50" data-id="element-1696" data-mp="252fv1mpk585u">
            {creators.map((c, i) => <tr key={i} className="hover:bg-gray-50" data-id="element-1697" data-mp="203v4kf03y2ul" data-mpi={i}>
                <td className="px-3 py-2 flex items-center gap-2" data-id="element-1698" data-mp="2xm4v3hooxttx">
                  <div className="w-5 h-5 bg-gray-200 rounded-full shrink-0" data-id="element-1699" data-mp="2sumvoy2bg1b2"></div>
                  <span className="font-medium text-gray-900 truncate max-w-[100px]" data-id="element-1700" data-mp="2dcd7f9w7uw2x">
                    {c.name}
                  </span>
                </td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1701" data-mp="2hfi9jbcdwvr1">{c.cat}</td>
                <td className="px-3 py-2 text-gray-600 truncate max-w-[80px]" data-id="element-1702" data-mp="23ez2o7jnnvqg">
                  {c.country}
                </td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1703" data-mp="28dshc3aohss7">{c.tt}</td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1704" data-mp="2w2l5hdl26wc9">{c.ig}</td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1705" data-mp="2w57fdjvf9nxn">{c.yt}</td>
                <td className="px-3 py-2 text-gray-700 truncate max-w-[100px]" data-id="element-1706" data-mp="311emvh3gv7hp">
                  {c.agency}
                </td>
                <td className="px-3 py-2 text-gray-500" data-id="element-1707" data-mp="2mb793eoemcnc">{c.excl}</td>
                <td className="px-3 py-2 text-gray-500 flex items-center justify-between gap-2" data-id="element-1708" data-mp="2rajxw4yu5tsk">
                  <span className="truncate max-w-[120px]" data-id="element-1709" data-mp="3f04jywqad762">{c.email}</span>
                  <Copy size={10} className="text-gray-400 shrink-0" data-id="element-1710" data-mp="3jth4ovrugttj" />
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </MockupLayout>;
};
export const InsightsMockup = () => {
  return <MockupLayout active="Dashboard" title="Dashboard" data-id="element-1711" data-mp="13c9fh1u13t16">
      <div className="space-y-4" data-id="element-1712" data-mp="1h4p9xe8v6iqh">
        <div data-id="element-1713" data-mp="1h4yz4zm34lv4">
          <h3 className="text-xs font-bold text-gray-700 uppercase tracking-wider mb-2" data-id="element-1714" data-mp="1h7l915wg7dgi">
            Talent Agencies
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3" data-id="element-1715" data-mp="pe2pe7vbmxc2">
            {[{
            title: 'TikTok Top Agencies',
            icon: <TTIco data-id="element-1716" data-mp="khkmzengrb2w" />,
            data: [{
              n: 'United Talent Agency',
              v: '1,886,760,587'
            }, {
              n: 'Viral Nation Inc',
              v: '758,591,677'
            }]
          }, {
            title: 'Instagram Top Agencies',
            icon: <IGIco data-id="element-1717" data-mp="24xfn1qsi782c" />,
            data: [{
              n: 'United Talent Agency',
              v: '1,169,648,463'
            }, {
              n: 'Clicks Talent',
              v: '284,615,765'
            }]
          }, {
            title: 'YouTube Top Agencies',
            icon: <YTIco data-id="element-1718" data-mp="1gfbzu1g12umv" />,
            data: [{
              n: 'Clicks Talent',
              v: '916,534,313'
            }, {
              n: 'Viral Nation Inc',
              v: '286,009,190'
            }]
          }].map(col => <div key={col.title} className="bg-white border border-gray-200 rounded-lg p-3" data-id="element-1719" data-mp="xjvl3u1r9raz">
                <div className="flex items-center gap-1 text-xs font-semibold text-gray-900 mb-3" data-id="element-1720" data-mp="1ltsp5clwal">
                  {col.icon} {col.title}
                </div>
                <div className="space-y-2" data-id="element-1721" data-mp="3tn37whpxpjg1">
                  {col.data.map(d => <div key={d.n} className="flex justify-between items-center text-[10px]" data-id="element-1722" data-mp="3oqcr1s6b2jtk">
                      <div className="flex items-center gap-1" data-id="element-1723" data-mp="3fon2cu3t5yzh">
                        <div className="w-3 h-3 bg-gray-900 rounded-full shrink-0" data-id="element-1724" data-mp="3fo3llgpw9gn1"></div>
                        <span className="text-gray-700 truncate max-w-[80px]" data-id="element-1725" data-mp="3aqbom8ae74bz">
                          {d.n}
                        </span>
                      </div>
                      <span className="text-gray-500 font-medium" data-id="element-1726" data-mp="30z7997gt1hgm">{d.v}</span>
                    </div>)}
                </div>
              </div>)}
          </div>
        </div>

        <div data-id="element-1727" data-mp="2rzbwwzbijgf0">
          <h3 className="text-xs font-bold text-gray-700 uppercase tracking-wider mb-2" data-id="element-1728" data-mp="2rxr1z8ladvgm">
            Pricing
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3" data-id="element-1729" data-mp="2n0r4hm2i6114">
            {[{
            title: 'TikTok Pricing',
            icon: <TTIco data-id="element-1730" data-mp="jqvy9z2xjen2" />,
            data: [{
              n: 'Video Post',
              v: '$7,746'
            }, {
              n: 'Link in Bio',
              v: '$5,378'
            }]
          }, {
            title: 'Instagram Pricing',
            icon: <IGIco data-id="element-1731" data-mp="rhzn3u99fq8" />,
            data: [{
              n: 'Photo',
              v: '$7,102'
            }, {
              n: 'Reels',
              v: '$8,722'
            }]
          }, {
            title: 'YouTube Pricing',
            icon: <YTIco data-id="element-1732" data-mp="397tm5711wjse" />,
            data: [{
              n: 'Integration',
              v: '$6,196'
            }, {
              n: 'Dedication',
              v: '$8,995'
            }]
          }].map(col => <div key={col.title} className="bg-white border border-gray-200 rounded-lg p-3" data-id="element-1733" data-mp="33laxskf0yui0">
                <div className="flex items-center gap-1 text-xs font-semibold text-gray-900 mb-3" data-id="element-1734" data-mp="2zimmm62u9bhv">
                  {col.icon} {col.title}
                </div>
                <div className="space-y-2" data-id="element-1735" data-mp="38knkn55wc1kl">
                  {col.data.map(d => <div key={d.n} className="flex justify-between items-center text-[10px]" data-id="element-1736" data-mp="38ijfkjw9gwiq">
                      <span className="text-gray-600" data-id="element-1737" data-mp="3iap9hz62po0k">{d.n}</span>
                      <span className="text-green-600 font-medium" data-id="element-1738" data-mp="415ydqo98x0">{d.v}</span>
                    </div>)}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </MockupLayout>;
};
export const MediaKitLinkMockup = () => <MockupLayout active="Talent Agencies" title="Media Kits" data-id="element-1739" data-mp="3mm8v1fyaxen">
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-1740" data-mp="3mcktjegv0bl">
      <div className="border-b border-gray-100 p-4 flex items-center gap-2 bg-gray-50/50" data-id="element-1741" data-mp="hlvghcq3cj70">
        <Link2 size={16} className="text-gray-500" data-id="element-1742" data-mp="colqnvysi5in" />
        <span className="font-semibold text-sm text-gray-800 flex-1" data-id="element-1743" data-mp="3l2ueyrua4a50">
          zano.co/agency/uta
        </span>
        <span className="text-xs text-zano-pink font-medium" data-id="element-1744" data-mp="3g4j3yds8ztl7">Copy link</span>
      </div>
      <div className="px-4 pt-3 flex items-center gap-2" data-id="element-1745" data-mp="3usngt14mdaw2">
        <div className="flex-1 bg-gray-50 border border-gray-200 rounded-md px-2.5 py-1 text-xs text-gray-400 flex items-center gap-1" data-id="element-1746" data-mp="3uu8a6nf76nsc">
          <Search size={11} data-id="element-1747" data-mp="32ccrb1ob04qi" /> Filter by followers, niche, location…
        </div>
      </div>
      <div className="p-4 grid grid-cols-2 gap-3" data-id="element-1748" data-mp="2xdjaaz9t5vll">
        {[1, 2].map(c => <div key={c} className="border border-gray-100 rounded-lg p-3" data-id="element-1749" data-mp="2xbp0ag02rnwa">
            <div className="w-10 h-10 bg-gray-200 rounded-full mb-2" data-id="element-1750" data-mp="1ctxrnj1whjyl"></div>
            <div className="flex items-center gap-1.5" data-id="element-1751" data-mp="1hn8xphyw1wpg">
              <p className="text-sm font-semibold text-gray-900" data-id="element-1752" data-mp="13usrk8aoxikb">
                Creator Name
              </p>
            </div>
            <p className="text-xs text-gray-500" data-id="element-1753" data-mp="17vmfv2s1ozdq">1.2M • 4.8% ENG</p>
          </div>)}
      </div>
    </div>
  </MockupLayout>;
export const MediaKitMockup = () => <MockupLayout active="Talent Agencies" title="Creator Profile" data-id="element-1754" data-mp="20l337m0t5q33">
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-1755" data-mp="20ka5tbnqocxm">
      <div className="bg-gray-50 border-b border-gray-200 p-4 flex items-center gap-3" data-id="element-1756" data-mp="1mksbkgroc7gv">
        <div className="w-12 h-12 bg-gray-200 rounded-full" data-id="element-1757" data-mp="1rj27itl83c3j"></div>
        <div data-id="element-1758" data-mp="b5lttbj28x04">
          <h4 className="font-bold text-gray-900" data-id="element-1759" data-mp="b5vj0wwa704r">Elena Rodriguez</h4>
          <p className="text-xs text-gray-500 flex items-center gap-1" data-id="element-1760" data-mp="g587fm2swf9g">
            <Globe size={12} data-id="element-1761" data-mp="g356i70411py" /> LA • UTA
          </p>
        </div>
      </div>
      <div className="p-4 grid grid-cols-3 gap-3" data-id="element-1762" data-mp="2ht2q9odpv16z">
        <div className="bg-gray-50 rounded-lg p-3 border border-gray-100" data-id="element-1763" data-mp="2cvkochy49m8h">
          <p className="text-[10px] text-gray-500 uppercase" data-id="element-1764" data-mp="2cxdtfst2zyed">Followers</p>
          <p className="text-lg font-bold text-gray-900" data-id="element-1765" data-mp="2831bxob60x59">1.2M</p>
        </div>
        <div className="bg-gray-50 rounded-lg p-3 border border-gray-100" data-id="element-1766" data-mp="241xw31t4b141">
          <p className="text-[10px] text-gray-500 uppercase" data-id="element-1767" data-mp="1z4fj90bzc1qr">Avg views</p>
          <p className="text-lg font-bold text-gray-900" data-id="element-1768" data-mp="1z1jmvgfs5l4f">340K</p>
        </div>
        <div className="bg-gray-50 rounded-lg p-3 border border-gray-100" data-id="element-1769" data-mp="1u3i46wm9nnth">
          <p className="text-[10px] text-gray-500 uppercase" data-id="element-1770" data-mp="1p6hwkh9rqd09">Eng.</p>
          <p className="text-lg font-bold text-gray-900" data-id="element-1771" data-mp="1l4mwth7hk7ol">4.8%</p>
        </div>
      </div>
    </div>
  </MockupLayout>;
export const RosterMockup = () => <MockupLayout active="Talent Agencies" title="Your Roster" data-id="element-1772" data-mp="3jiy9u20zerem">
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-1773" data-mp="3fhw6pa3y1v7d">
      <div className="border-b border-gray-100 p-4 bg-gray-50/50 flex justify-between items-center" data-id="element-1774" data-mp="11b6gt13rpp50">
        <span className="font-semibold text-sm text-gray-800" data-id="element-1775" data-mp="168oetwg8yjy8">Your Roster</span>
        <span className="text-xs text-zano-pink font-medium" data-id="element-1776" data-mp="1b0gagle9ffv8">
          + Add creator
        </span>
      </div>
      <div className="p-4 grid grid-cols-2 gap-4" data-id="element-1777" data-mp="1f2bc5r03rv9j">
        <div className="border border-gray-100 rounded-lg p-3 bg-gray-50" data-id="element-1778" data-mp="1f3w3l7r4ey36">
          <p className="text-xs text-gray-500 mb-1" data-id="element-1779" data-mp="icu3r49qjv45">Active roster</p>
          <p className="text-xl font-bold text-gray-900" data-id="element-1780" data-mp="na3viqklkiv5">42</p>
        </div>
        <div className="border border-gray-100 rounded-lg p-3 bg-gray-50" data-id="element-1781" data-mp="rc77rhf3brhh">
          <p className="text-xs text-gray-500 mb-1" data-id="element-1782" data-mp="rebj2kfbjsrs">Casting inbound</p>
          <p className="text-xl font-bold text-gray-900" data-id="element-1783" data-mp="wc3918wel4tc">18</p>
        </div>
      </div>
    </div>
  </MockupLayout>;
export const PartnerRosterMockup = () => <MockupLayout active="Talent Agencies" title="Partner Agencies" data-id="element-1784" data-mp="27q728cv62oxc">
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-1785" data-mp="27sjubiun2fo4">
      <div className="border-b border-gray-100 p-4 bg-gray-50/50 flex items-center gap-2" data-id="element-1786" data-mp="269jt6m7vmkzs">
        <span className="font-semibold text-sm text-gray-800" data-id="element-1787" data-mp="21brsp3t61qjz">
          My partner agencies
        </span>
      </div>
      <div className="px-4 pt-3 flex gap-1.5" data-id="element-1788" data-mp="2f7vi8jt3haq4">
        {['UTA', 'Viral Nation', 'Fixated'].map(a => <span key={a} className="text-[10px] text-zano-pink bg-zano-blush rounded-full px-2 py-0.5 font-medium" data-id="element-1789" data-mp="2bar0yla0rk6g">
            {a}
          </span>)}
      </div>
      <div className="p-4 space-y-3" data-id="element-1790" data-mp="2yxz7t7n3j1al">
        {[1, 2].map(c => <div key={c} className="flex items-center justify-between p-3 border border-gray-100 rounded-lg" data-id="element-1791" data-mp="2yx5xjwoxhtnp">
            <div className="flex items-center gap-3" data-id="element-1792" data-mp="37ydsq5w5eedk">
              <div className="w-9 h-9 bg-gray-200 rounded-full" data-id="element-1793" data-mp="37yx2gzbn9wgi"></div>
              <div data-id="element-1794" data-mp="330lt0pp9hnyt">
                <p className="text-sm font-semibold text-gray-900" data-id="element-1795" data-mp="3315cwbyh2mfh">
                  Creator {c}
                </p>
                <p className="text-xs text-gray-500" data-id="element-1796" data-mp="3mj9igjkhpr7q">Agency • live roster</p>
              </div>
            </div>
            <span className="text-xs bg-green-50 text-green-700 border border-green-200 px-2 py-0.5 rounded-full" data-id="element-1797" data-mp="3ri2vybzs1i7w">
              Updated
            </span>
          </div>)}
      </div>
    </div>
  </MockupLayout>;